// @flow

import assert from 'assert';

import ko from 'rgs-knockout';
import _ from 'lodash';

import moment from 'moment';

import server from 'server';
import debug from 'debug';

const ACCURACIES = {
	year: 'year',
};


debug.define({
	serverTime: {
		value: 'string',
	},
});


class ServerTimeApi {
	constructor (options) {
		this._serverTime = ko.observable();

		// computed для мемоизации значения года
		this._serverYear = ko.pureComputed(() => this._serverTime().year());

		this._firstUpdate = this.update();
		this._firstUpdate.done();

		this.setIntervals(options);

		this._timeOfLastUpdate = ko.observable();
	}

	_correctByServer () {
		return server.any.api.dictionary.getCurrentTime()
			.then((response) => response.responseJSON.Data.currentTime)
			.then((date) => moment.parseZone(date))
			.then((m) => {
				this._serverTime(m);
				this._timeOfLastUpdate(moment.utc());
				return m;
			});
	}

	update () {
		return this._correctByServer();
	}

	ready () {
		return this._firstUpdate;
	}

	serverTime (accuracy: ?$Values<ACCURACIES>) {
		assert(
			this.ready().inspect().state === 'fulfilled',
			'Wait for `.ready()` before using `observable-server-time`'
		);

		switch (accuracy) {
			case ACCURACIES.year: {
				return this._serverYear();
			}
			default: {
				return this._serverTime().clone();
			}
		}
	}

	timeOfLastUpdate () {
		return this._timeOfLastUpdate().clone();
	}

	subscribe (callback) {
		return this._serverTime.subscribe(value => callback(value.clone()));
	}

	setIntervals (options) {
		options = _.defaults({}, options, {
			interval: moment.duration(1, 'seconds'),
			correctionByServerInterval: moment.duration(5, 'minutes'),
		});

		if (this._updateInterval) {
			clearInterval(this._updateInterval);
		}

		if (this._correctionByServerInterval) {
			clearInterval(this._correctionByServerInterval);
		}

		this._updateInterval = setInterval(
			() => {
				let stubValue = debug.get('serverTime.value');
				stubValue = stubValue ? moment(stubValue, 'DD.MM.YYYY HH:mm:ss') : null;

				if (this._serverTime()) {
					this._serverTime(stubValue || this._serverTime().add(options.interval));
				}
			},
			options.interval.asMilliseconds()
		);

		this._correctionByServerInterval = setInterval(
			this.update.bind(this),
			options.correctionByServerInterval.asMilliseconds()
		);
	}
}


const {
	update,
	ready,
	serverTime,
	subscribe,
	timeOfLastUpdate,
	setIntervals,
} = _.bindAll(new ServerTimeApi, [
	'update',
	'ready',
	'serverTime',
	'subscribe',
	'timeOfLastUpdate',
	'setIntervals',
]);

export {
	update,
	ready,
	serverTime,
	subscribe,
	timeOfLastUpdate,
	setIntervals,
};
